// <auto-generated>
// This file is automatically generated from DSL.
// Do not modify this file directly. Changes will be overwritten.
// Generated: 2025-11-16T16:07:00.754Z
// </auto-generated>

import { lazy, Suspense } from 'react';

const InventoryPeriodCloseListView = lazy(() => import('@/inventory/InventoryPeriodCloseListView').then(m => ({ default: m.InventoryPeriodCloseListView })));
const InventoryPeriodCloseDetailView = lazy(() => import('@/inventory/InventoryPeriodCloseDetailView').then(m => ({ default: m.InventoryPeriodCloseDetailView })));
const InventoryPostingProfileListView = lazy(() => import('@/inventory/InventoryPostingProfileListView').then(m => ({ default: m.InventoryPostingProfileListView })));
const InventoryPostingProfileDetailView = lazy(() => import('@/inventory/InventoryPostingProfileDetailView').then(m => ({ default: m.InventoryPostingProfileDetailView })));
const InventoryReservationListView = lazy(() => import('@/inventory/InventoryReservationListView').then(m => ({ default: m.InventoryReservationListView })));
const InventoryReservationDetailView = lazy(() => import('@/inventory/InventoryReservationDetailView').then(m => ({ default: m.InventoryReservationDetailView })));
const InventoryTransactionListView = lazy(() => import('@/inventory/InventoryTransactionListView').then(m => ({ default: m.InventoryTransactionListView })));
const InventoryTransactionDetailView = lazy(() => import('@/inventory/InventoryTransactionDetailView').then(m => ({ default: m.InventoryTransactionDetailView })));
const ProductListView = lazy(() => import('@/inventory/ProductListView').then(m => ({ default: m.ProductListView })));
const ProductDetailView = lazy(() => import('@/inventory/ProductDetailView').then(m => ({ default: m.ProductDetailView })));
const StandardCostVersionListView = lazy(() => import('@/inventory/StandardCostVersionListView').then(m => ({ default: m.StandardCostVersionListView })));
const StandardCostVersionDetailView = lazy(() => import('@/inventory/StandardCostVersionDetailView').then(m => ({ default: m.StandardCostVersionDetailView })));
const InventoryProductGroupAdminPage = lazy(() => import('@/inventory/InventoryProductGroupAdminPage.generated').then(m => ({ default: m.default })));

/**
 * Inventory Module Routes
 */
export const inventoryRoutes = [
{ path: '/inventory/inventoryperiodcloses',
element: <Suspense><InventoryPeriodCloseListView /></Suspense> },
{ path: '/inventory/inventoryperiodcloses/:id',
element: <Suspense><InventoryPeriodCloseDetailView /></Suspense> },
{ path: '/inventory/inventorypostingprofiles',
element: <Suspense><InventoryPostingProfileListView /></Suspense> },
{ path: '/inventory/inventorypostingprofiles/:id',
element: <Suspense><InventoryPostingProfileDetailView /></Suspense> },
{ path: '/inventory/inventoryreservations',
element: <Suspense><InventoryReservationListView /></Suspense> },
{ path: '/inventory/inventoryreservations/:id',
element: <Suspense><InventoryReservationDetailView /></Suspense> },
{ path: '/inventory/inventorytransactions',
element: <Suspense><InventoryTransactionListView /></Suspense> },
{ path: '/inventory/inventorytransactions/:id',
element: <Suspense><InventoryTransactionDetailView /></Suspense> },
{ path: '/inventory/products',
element: <Suspense><ProductListView /></Suspense> },
{ path: '/inventory/products/:id',
element: <Suspense><ProductDetailView /></Suspense> },
{ path: '/inventory/products/template/new',
element: <Suspense><ProductDetailView mode="template" /></Suspense> },
{ path: '/inventory/products/template/:templateId',
element: <Suspense><ProductDetailView mode="template" /></Suspense> },
{ path: '/inventory/standardcostversions',
element: <Suspense><StandardCostVersionListView /></Suspense> },
{ path: '/inventory/standardcostversions/:id',
element: <Suspense><StandardCostVersionDetailView /></Suspense> },
{ path: '/inventory/inventoryproductgroups', element: <Suspense><InventoryProductGroupAdminPage /></Suspense> }
];
